import { useMemo } from "react";
import { useQuery } from "react-query";
import { fetchLatestPublisherPrefixes } from "../api/aresService";
var EMPTY = {};
/**
 * Latest assigned prefix (by `dateCreated`) of the publishers of the given
 * ARES update rows, loaded with ONE request per set of publishers (DB-889).
 * The query key is the sorted, de-duplicated id list, so re-ordering the same
 * rows does not ask again and paging/sorting asks at most once more. A failed
 * load is not retried; `isError` tells the caller to show it.
 *
 * @param ky okapi ky instance
 * @param rows ARES update requests shown on the current table page
 */
export var useLatestPublisherPrefixes = function (ky, rows) {
    var publisherIds = useMemo(function () {
        return Array.from(new Set(rows
            .map(function (item) { var _a; return (_a = item.publisher) === null || _a === void 0 ? void 0 : _a.id; })
            .filter(function (id) { return !!id; }))).sort();
    }, [rows]);
    var _a = useQuery(["ares-latest-prefixes", publisherIds], function () { return fetchLatestPublisherPrefixes(ky, publisherIds); }, {
        enabled: publisherIds.length > 0,
        keepPreviousData: true,
        retry: false,
    }), data = _a.data, isLoading = _a.isLoading, isError = _a.isError;
    return { prefixByPublisher: data !== null && data !== void 0 ? data : EMPTY, isLoading: isLoading, isError: isError };
};
